<template>
    <div class="column">
        <table class="table is-fullwidth is-bordered">
            <thead>
            <tr>
                <th class="narrow"></th>
                <th>Cost Item</th>
                <th>Remarks</th>
                <th>Amount</th>
                <th class="narrow"></th>
            </tr>
            </thead>
            <tbody>
            <proforma-invoice-costs-table-row v-for="(item, index) in items" :item="item" :index="index"></proforma-invoice-costs-table-row>
            <proforma-invoice-costs-table-create-row></proforma-invoice-costs-table-create-row>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ProformaInvoiceCostsTableRow from './ProformaInvoiceCostsTableRow'
    import ProformaInvoiceCostsTableCreateRow from './ProformaInvoiceCostsTableCreateRow'
    export default {
        props:['car'],
        components: {
            ProformaInvoiceCostsTableRow,
            ProformaInvoiceCostsTableCreateRow
        },
        computed: {
            items() {
                return this.$store.getters.getProformaInvoiceCostItems
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
    .narrow {
        width: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceCostsTable.vue